/**
 * @file   src\mobile\components\createWantAd\Exterior.js
 * @brief  This file is responsible for nice to haves section subcomponent
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const Exterior = (props) => {
  const { exterior, handleItemClick, itemArray } = props;
  return (
    <NiceToHaveHelper
      list={exterior}
      selectedItems={itemArray}
      propertyClick={handleItemClick}
    />
  );
};
export default Exterior;
